module.exports = __webpack_public_path__ + "media/images/hero-image-11795633ce72914b77665638e98269f0.jpg";